import { currentCallDetail } from '../../models/callModel';
import { Types } from '../action/action';

const initialState = {
  callDetails: [],
  minimizedWindow: false,
  isWindowSlide: true,
  isCallActive: false,
  isCallFullScreen: false,
  actionType: '',
  leftSideWindow: 'callList',
  centerWindow: 'callDetail',
  rightSideWindow: 'dialpad',
  callPlusIcon: false,
  callIconStatus: '',
  isTranscriptionOnOff: true,
  isGroupCall: false,
  groupCallInfo: {
    'TeamID':'',
    'Host':'',
    'DomainId':'',
    'GroupDetails':{},
    'IndividualDetails':{},
    'PSTNDetails':{}
    
   },
  isAddCall:false,
  isGroupHost:false,
  isMuteAll:false,
  isTeamCallHold:false,
  internalUsers:[],
  externalUsers:[],
  callType:'',
  isProfileView:false
};

export const updatedCallList = (state: currentCallDetail = initialState, action: any) => {
  const {
    type,
    payloads
  } = action;
  switch (type) {

  case Types.UPDATDE_CALL_LIST:
    return {
      ...state, callDetails: payloads
    };
  case Types.CALL_LIST_TYPE:
    return {
      ...state, leftSideWindow: payloads.leftSideWindow
    };
  case Types.CALL_MINI_WINDOW:
    return {
      ...state, isWindowSlide: payloads.isWindowSlide, minimizedWindow: payloads.minimizedWindow,
      centerWindow: payloads.centerWindow,isCallFullScreen:payloads.isCallFullScreen
    };
  case Types.UPDATDE_WINDOW_SLIDE:
    return {
      ...state, isWindowSlide: payloads.isWindowSlide, isCallFullScreen: payloads.isCallFullScreen,
      rightSideWindow: payloads.rightSideWindow,isTranscriptionOnOff:payloads.isTranscriptionOnOff
    };
  case Types.UPDATE_CALL_INFO:
    return {
      ...state, callDetails: payloads.callDetails, minimizedWindow: payloads.minimizedWindow,
      isCallActive: payloads.isCallActive,centerWindow:payloads.centerWindow,
      isWindowSlide: payloads.isWindowSlide, isCallFullScreen: payloads.isCallFullScreen,
      rightSideWindow: payloads.rightSideWindow
    };
  case Types.CALL_END_WINDOW:
    return {
      ...state, isWindowSlide: payloads.isWindowSlide, minimizedWindow: payloads.minimizedWindow,
      callDetails: payloads.callDetails, isCallFullScreen: payloads.isCallFullScreen,
      isCallActive: payloads.isCallActive, rightSideWindow: payloads.rightSideWindow,
      centerWindow:payloads.centerWindow,isTranscriptionOnOff:payloads.isTranscriptionOnOff
    };
  case Types.UPDATE_CALL_STATUS:
    return {
      ...state, isWindowSlide: payloads.isWindowSlide, isCallFullScreen: payloads.isCallFullScreen,
      rightSideWindow: payloads.rightSideWindow, minimizedWindow: payloads.minimizedWindow,
      isTranscriptionOnOff:payloads.isTranscriptionOnOff
    };
    case Types.CALL_POPOUT:
      return {
        ...state, isWindowSlide: payloads.isWindowSlide, minimizedWindow: payloads.minimizedWindow,
        centerWindow: payloads.centerWindow, rightSideWindow: payloads.rightSideWindow,
        isTranscriptionOnOff:payloads.isTranscriptionOnOff
      };
    case Types.CALL_PLUS_ICON:
      return {
        ...state, callPlusIcon: payloads.callPlusIcon, callIconStatus: payloads.callIconStatus,
        minimizedWindow:payloads.minimizedWindow
      }
    case Types.TRANSCRIPT_MODE:
      return {
        ...state, isTranscriptionOnOff:payloads.isTranscriptionOnOff
      };
      
      case Types.ADD_CALL:
        return {
          ...state, isAddCall:payloads.isAddCall
        };
        case Types.TEAM_CALL_HOLD:
          return {
            ...state,isTeamCallHold:payloads.isTeamCallHold,internalUsers:payloads.internalUsers,externalUsers:payloads.externalUsers,callType:payloads.callType
          };
      case Types.OPEN_PROFILE_VIEW:
      return {
        ...state, isProfileView:payloads.isProfileView
      };
      case Types.UPDATE_RIGHT_WINDOOW:
      return {
        ...state, rightSideWindow:payloads.rightSideWindow
      };
  default:
    return state;
  };
};